import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import SimpleReactValidator from 'simple-react-validator';
import { connect } from 'react-redux';
import { buyerChangePassword } from '../../Action/buyerChangePassword';
import { withRouter } from 'react-router-dom';
import {withTranslation} from "react-i18next";
class BuyerChangePasswod extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 1) {
            alert(this.props.t('LOGIN_ALERT'))
            this.props.history.push('/login');
        };
        this.state = {
            _id: false,
            currentPassword: '',
            newPassword: '',
            newConfirmPassword: ''
        }
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    };
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    handleSubmit(e) {
        e.preventDefault();
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        if (this.validator.allValid()) {
            if (this.state.newPassword === this.state.newConfirmPassword) {

                let data = {}
                data = {
                    user_id: logged_user.id,
                    password_old: this.state.currentPassword,
                    password_new: this.state.newPassword,
                }
                // console.log(data)
                this.props.buyerChangePassword(data, this.props.history);

            } else {
                this.validator.showMessages();
            }
        }
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <BuyerSidebar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: "100%",fontSize:'20px' }}>
                                    {this.props.t('BUYER_CHANGE_PASSWORD.BUYER_CHANGE_PASSWORD_TITLE')}
                                        </div>
                                <form onSubmit={this.handleSubmit.bind(this)}>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="exampleInputEmail1" className="mt-1"> {this.props.t('BUYER_CHANGE_PASSWORD.CURRENT_PASSWORD')} :</label>
                                            </div>
                                            <div className="col-md-8">
                                                <input type="password" class="form-control input_form" value={this.state.currentPassword} onChange={this.updateValue.bind(this, 'currentPassword')} onBlur={() => this.validator.showMessageFor('currentPassword')} />
                                                {this.validator.message('currentPassword', this.state.currentPassword, 'required|currentPassword')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="exampleInputEmail1" className="mt-1"> {this.props.t('BUYER_CHANGE_PASSWORD.NEW_PASSWORD')} :</label>
                                            </div>
                                            <div className="col-md-8">
                                                <input type="password" class="form-control input_form" value={this.state.newPassword} onChange={this.updateValue.bind(this, 'newPassword')} onBlur={() => this.validator.showMessageFor('newPassword')} />
                                                {this.validator.message('newPassword', this.state.newPassword, 'required|newPassword')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label htmlFor="exampleInputEmail1" className="mt-1">{this.props.t('BUYER_CHANGE_PASSWORD.CONFIRM_NEW_PASSWORD')} :</label>
                                            </div>
                                            <div className="col-md-8">
                                                <input type="password" class="form-control input_form" value={this.state.newConfirmPassword} onChange={this.updateValue.bind(this, 'newConfirmPassword')} onBlur={() => this.validator.showMessageFor('newConfirmPassword')} />
                                                {this.validator.message('newConfirmPassword', this.state.newConfirmPassword, 'required|newConfirmPassword')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center p-3 mt-3" >
                                        <button type="submit" className="btn btn-lg  " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                            <span className="fa fa-check"></span>
                                            {this.props.t('BUYER_CHANGE_PASSWORD.UPDATE_BTN')}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //For Desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className=" mb-1 input_name big_font guide_text" style={{ width: "100%" }}>
                                            {this.props.t('BUYER_CHANGE_PASSWORD.BUYER_CHANGE_PASSWORD_TITLE')}
                                        </div>
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label htmlFor="exampleInputEmail1" className="mt-1"> {this.props.t('BUYER_CHANGE_PASSWORD.CURRENT_PASSWORD')}</label>
                                                    </div>
                                                    <div className="col-md-1 mt-1">:</div>
                                                    <div className="col-md-8">
                                                        <input type="password" class="form-control input_form" value={this.state.currentPassword} onChange={this.updateValue.bind(this, 'currentPassword')} onBlur={() => this.validator.showMessageFor('currentPassword')} />
                                                        {this.validator.message('currentPassword', this.state.currentPassword, 'required|currentPassword')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label htmlFor="exampleInputEmail1" className="mt-1"> {this.props.t('BUYER_CHANGE_PASSWORD.NEW_PASSWORD')}</label>
                                                    </div>
                                                    <div className="col-md-1 mt-1">:</div>
                                                    <div className="col-md-8">
                                                        <input type="password" class="form-control input_form" value={this.state.newPassword} onChange={this.updateValue.bind(this, 'newPassword')} onBlur={() => this.validator.showMessageFor('newPassword')} />
                                                        {this.validator.message('newPassword', this.state.newPassword, 'required|newPassword')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label htmlFor="exampleInputEmail1" className="mt-1">{this.props.t('BUYER_CHANGE_PASSWORD.CONFIRM_NEW_PASSWORD')}</label>
                                                    </div>
                                                    <div className="col-md-1 mt-1">:</div>
                                                    <div className="col-md-8">
                                                        <input type="password" class="form-control input_form" value={this.state.newConfirmPassword} onChange={this.updateValue.bind(this, 'newConfirmPassword')} onBlur={() => this.validator.showMessageFor('newConfirmPassword')} />
                                                        {this.validator.message('newConfirmPassword', this.state.newConfirmPassword, 'required|newConfirmPassword')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-center p-3 mt-3" >
                                                <button type="submit" className="btn btn-lg  " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                    <span className="fa fa-check"></span>
                                                    {this.props.t('BUYER_CHANGE_PASSWORD.UPDATE_BTN')}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    buyerChangePassword: state.buyerChangePassword,
    errors: state.errors,
});

BuyerChangePasswod = connect(mapStateToProps, { buyerChangePassword })(withRouter(BuyerChangePasswod));
export { BuyerChangePasswod }
BuyerChangePasswod = withTranslation('buyer')(BuyerChangePasswod);
